<!-- prettier-ignore -->
<section *ngIf="statusCode == 0" class="recent-news">
  <h3 class="heading">{{ "HOME.LATEST-NEWS" | translate }}</h3>

    <app-news-card
        *ngFor="let news of registers"
        [title]="news.sinopse?.length > 140 ? (news.sinopse | slice: 0:140) + '[...]' : news.sinopse"
        [image]="news.images && news.images[0]?.mini"
        [date]="news.dt_post"
        [type]="'simple'"
        [link]="'/news/' + news.url_amigavel"
    >
    </app-news-card>
    <app-shared-pagination
        [perPage]="perPage"
        [size]="total"
        (onChange)="onPageChange($event)"
        *ngIf="total > 0"
    ></app-shared-pagination>
</section>
